import { render, staticRenderFns } from "./UpdateEvaluation.vue?vue&type=template&id=80abe4b2&scoped=true&"
import script from "./UpdateEvaluation.vue?vue&type=script&lang=js&"
export * from "./UpdateEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./UpdateEvaluation.vue?vue&type=style&index=0&id=80abe4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80abe4b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
